import { handlers } from "@/mocks/handlers";
import { setupWorker } from "msw/browser";

export default defineNuxtPlugin(async () => {
  if (process.env.NODE_ENV === "development") {
    const worker = setupWorker(...handlers);
    await worker.start({
      onUnhandledRequest: "bypass",
      serviceWorker: {
        url: "/mockServiceWorker.js",
      },
    });

    console.log("[RDP] MSW initialized in development mode");
  }
});
